import React, { useState, useEffect, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import axios from "../../axios";
import * as moment from "moment";

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import ClipLoader from "react-spinners/ClipLoader";
import { NotificationManager } from "react-notifications";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import { registerLicense } from "@syncfusion/ej2-base";
registerLicense(
  "ORg4AjUWIQA/Gnt2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5RdEVjXntdcHNVQGda;MzExNjY5OUAzMjM0MmUzMDJlMzBFZmo4T0hTeUlZQjB3cjhSVFkvT0tLUDFUVEtMZU9NQXljVHk3dXloYnJ3PQ=="
);

const ExportDataDialog = (props) => {
  let date = moment(new Date());
  console.log(date);

  const [endDate, setEndDate] = useState(
    new Date(date.add(0, "day").valueOf())
  );

  const [startDate, setStartDate] = useState(
    new Date(date.subtract(1, "week").valueOf())
  );
  const [dates1, setDates1] = useState("");
  const [dates2, setDates2] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const dateRangePickerRef = useRef(null);
  const handleRangeSelected = (args) => {
  
    console.log(args);
    const startDate1 = args.value[0];
    const endDate1 = args.value[1];
    const startDate2 = moment(startDate1).format("YYYY-MM-DD");
    const endDate2 = moment(endDate1).format("YYYY-MM-DD");

    setStartDate(startDate2);
    setEndDate(endDate2);
    setSelectedOption("");
  };
  const handleDateRangePickerRef = (ref) => {
    if (ref && selectedOption === "custom") {
      ref.show();
    }
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);

    // Call respective handler functions based on selected option
    if (value === "1week") {
      oneWeekHandler();
      setShowDatePicker(false);
    } else if (value === "1day") {
      oneDayHandler();
      setShowDatePicker(false);
    } else if (value === "1month") {
      oneMonthHandler();
      setShowDatePicker(false);
    } else if (value === "1year") {
      oneYearHandler();
      setShowDatePicker(false);
    } else if (value === "custom") {
      setShowDatePicker(true);
    }
  };
  const oneWeekHandler = () => {
    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    setStartDate(new Date(newStartdate.subtract(7, "day").valueOf()));
    setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
  };
  const oneMonthHandler = () => {
    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    setStartDate(new Date(newStartdate.subtract(1, "month").valueOf()));
    setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
  };
  const oneDayHandler = () => {
    setSelectedOption("1day");
    const today = moment().startOf("day").toDate();
    setStartDate(today); // Set start date to today
    setEndDate(today); // Set end date to today
  };

  const oneYearHandler = () => {
    setSelectedOption("1year");
    // const startDate = moment().subtract(1, 'year').startOf('year').toDate();
    const startDate = moment().subtract(1, "year").toDate();
    const endDate = moment().toDate();
    setStartDate(startDate); // Set start date 1 year ago
    setEndDate(endDate); // Set end date to end of this year
  };
  useEffect(() => {
    const startDate1 = moment(startDate).format("YYYY-MM-DD");
    const endDate1 = moment(endDate).format("YYYY-MM-DD");
    setDates1(startDate1.toLocaleString());
    setDates2(endDate1.toLocaleString());
  });
  //Admin User
  const exportData = () => {
    setIsLoading(true);
    axios
      .get(
        `/export-data?adminId=${localStorage.doctorId.toLowerCase()}&created_on_start=${moment(
          startDate
        ).format("YYYY-MM-DD")} 00:00:00&created_on_end=${moment(
          endDate
        ).format("YYYY-MM-DD")} 23:59:59`,
        {
          headers: { accessToken: localStorage.accessToken },
          responseType: "blob",
        }
      )
      .then((response) => {
        setIsLoading(false);
        const contentType = response.headers["content-type"];
        if (contentType && contentType.includes("application/json")) {
          NotificationManager.error(
            "Patients/Records don't exist in this date range, Download not available",
            "",
            3000
          );
        } else {
          var today = new Date();
          var date =
            today.getFullYear() +
            "-" +
            (today.getMonth() + 1) +
            "-" +
            today.getDate();
          const fileName = localStorage.doctorId + "-(" + date + ").xlsx";
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
          NotificationManager.success("File Downloaded", "Success", 1000);
          setTimeout(() => {
            props.handleCloseExport();
          }, 1000);
        }
      })

      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        NotificationManager.error("Couldn't Download File", "", 3000);
      });
  };
  // General User
  const exportExecutiveData = () => {
    setIsLoading(true);
    axios
      .get(
        `/export-executive-data?doctorId=${encodeURIComponent(
          localStorage.doctorId.toLowerCase()
        )}&created_on_start=${moment(startDate).format(
          "YYYY-MM-DD"
        )} 00:00:00&created_on_end=${moment(endDate).format(
          "YYYY-MM-DD"
        )} 23:59:59`,
        {
          headers: { accessToken: localStorage.accessToken },
          responseType: "blob",
        }
      )
      .then((response) => {
        setIsLoading(false);
        const contentType = response.headers["content-type"];
        if (contentType && contentType.includes("application/json")) {
          NotificationManager.error(
            "Patients/Records don't exist in this date range, Download not available",
            "",
            3000
          );
        } else {
          var today = new Date();
          var date =
            today.getFullYear() +
            "-" +
            (today.getMonth() + 1) +
            "-" +
            today.getDate();
          const fileName = localStorage.doctorId + "-(" + date + ").xlsx";
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
          NotificationManager.success("File Downloaded", "Success", 1000);
          setTimeout(() => {
            props.handleCloseExport();
          }, 1000);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        NotificationManager.error("Couldn't Download File", "", 3000);
      });
  };

  return (
    <Dialog open={props.openExport}>
      <div className="dialog">
        <div className="dialog__header">Filter Export Data</div>

        <div className="dialog__exportdates">
          <div className="dateSelection" style={{ width: "350px" }}>
            <select
              className="selectDate"
              id="duration"
              value={selectedOption}
              onChange={handleChange}
            >
              <option>Date Range</option>
              <option value="1day">1 Day</option>
              <option value="1week">1 Week</option>
              <option value="1month">1 Month</option>
              <option value="1year">1 Year</option>
              <option value="custom" key="">
                Custom
              </option>
            </select>

            {showDatePicker && (
              <div className="dateRangePicker">
                <DateRangePickerComponent
                  id="daterangepicker"
                  placeholder="Select a range"
                  startDate={startDate}
                  endDate={endDate}
                  showClearButton={false}
                  onChange={handleRangeSelected}
                  ref={(ref) => handleDateRangePickerRef(ref)}
                  cssClass="custom-daterangepicker"
                />
              </div>
            )}
            <div className="dates-container">
              <p className="dates">{moment(dates1).format("DD-MM-YYYY")} </p>
              <p className="dates">to</p>
              <p className="dates">{moment(dates2).format("DD-MM-YYYY")} </p>
            </div>
          </div>
        </div>
        <div className="d-grid buttons justify-content-around">
          <button
            className="btn secondary-button"
            onClick={() => props.handleCloseExport()}
          >
            Close
          </button>
          {isLoading ? (
            <div
              className="btn primary-button"
              style={{
                width: "100px",
                textAlign: "center",
                paddingTop: "15px",
              }}
            >
              <ClipLoader color="white" size={20} />
            </div>
          ) : (
            <button
              className="btn primary-button"
              style={{ width: "100px" }}
              onClick={
                localStorage.user == "admin" ? exportData : exportExecutiveData
              }
            >
              Export Data
            </button>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default ExportDataDialog;
